import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

const Timer = ({ responseTime: responseTimeFromProps, timeIsUp, showResponses, presentedSlideID }) => {
    const { t } = useTranslation();
    const [responseTime, setResponseTime] = useState(responseTimeFromProps);

    useEffect(() => {
        setResponseTime(responseTimeFromProps);
    }, [responseTimeFromProps, presentedSlideID])

    useEffect(() => {
        const interval = setInterval(() => {
            setResponseTime(prevTime => {
                if (prevTime <= 1) {
                    clearInterval(interval);
                    showResponses();
                    return 0;
                } else {
                    return prevTime - 1;
                }
            });
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [responseTime, showResponses, setResponseTime]);
    return (
        <div>
            {timeIsUp ?
                <Typography variant="h4">{t('timeIsUp')}</Typography>
                : <Typography variant="h4">{t('timeRemaining')}{responseTime}s</Typography>
            }
        </div>
    );
};

export default Timer;
